import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54c3357e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-epic-sidebar-timeline" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-epic-sidebar-timeline__progress" }, null, -1))
const _hoisted_3 = { class: "hd-epic-sidebar-timeline__sections" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "hd-epic-sidebar-timeline__frames"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "hd-epic-sidebar-timeline__bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, indexSection) => {
        return (_openBlock(), _createElementBlock("div", {
          key: section.endpointId,
          class: _normalizeClass(["hd-epic-sidebar-timeline__sections-item", [
                    { 'is-active': _ctx.activeSection === section.endpointId },
                    { 'is-open': _ctx.sections.map(_ => _.endpointId).indexOf(_ctx.activeSection) >= indexSection }
                ]]),
          onClick: ($event: any) => (_ctx.switchSection(section.endpointId))
        }, [
          _createVNode(_component_lyra_asset, {
            class: "section-title",
            "asset-key": `epic-hr-sidebar-section-${section.endpointId}`
          }, null, 8, ["asset-key"]),
          _createVNode(_Transition, { name: "fade-in-up-right" }, {
            default: _withCtx(() => [
              (_ctx.activeSection === section.endpointId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeFrames, (frame, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: frame.endpointId,
                        class: _normalizeClass(["hd-epic-sidebar-timeline__frames-item", [
                                { 'is-active': _ctx.activeFrame === frame.endpointId },
                                { 'is-open': _ctx.activeFrames.map(_ => _.endpointId).indexOf(_ctx.activeFrame) >= index }
                            ]]),
                        onClick: ($event: any) => (_ctx.switchFrame(frame.endpointId))
                      }, [
                        _createVNode(_component_lyra_asset, {
                          "asset-key": `epic-hr-sidebar-frame-${frame.endpointId}`
                        }, null, 8, ["asset-key"])
                      ], 10, _hoisted_6))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ], 10, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_base_button, {
        callback: _ctx.processOverlay,
        callbackString: "citations",
        class: "crux-click",
        "data-crux": "citations-handle"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lyra_asset, { "asset-key": `app-link-button` })
        ]),
        _: 1
      }, 8, ["callback"])
    ])
  ]))
}